@for (section of sections; track $index; let isLast = $last) {
  <div class="sidebar-sections">
    @if (section.title) {
      <div class="section-title">
        <span class="section-title__text body-s bold">{{ section.title }}</span>
      </div>
    }
    <div class="section-items">
      @for (item of section.items; track item.uri || item.url || item.title || $index) {
        @if (item.expandable) {
          <div class="sidebar-item-expandable" [class.expanded]="item.expanded">
            <a
              class="sidebar-item"
              [routerLink]="item.url || item.uri || null"
              [routerLinkActive]="item.url || item.uri ? 'active' : ''"
              [class.active]="item.isActive"
              (click)="item.url || item.uri ? onItemClick($event, item) : toggleExpand($event, item)"
              tabindex="0"
              role="button"
            >
              <div class="item-content">
                @if (item.icon) {
                  <ptl-icon [size]="'m'" [icon]="item.icon"></ptl-icon>
                }
                <span class="item-title body-s bold">{{ item.title }}</span>
                <ptl-icon
                  class="expand-icon"
                  [size]="'s'"
                  [icon]="ArrowDown01Icon"
                  [class.rotated]="item.expanded"
                  (click)="toggleExpand($event, item)"
                ></ptl-icon>
              </div>
            </a>
            @if (item.expanded && item.children?.length) {
              @if (item.paginatedChildren) {
                <ptl-sidebar-expandable-children
                  [children]="item.children"
                  (childClick)="onItemClick($event.event, $event.item)"
                ></ptl-sidebar-expandable-children>
              } @else {
                <div class="sidebar-children">
                  @for (child of item.children; track child.uri || child.url || child.title || $index) {
                    <a
                      class="sidebar-item child-item"
                      [routerLink]="child.url || child.uri || null"
                      [routerLinkActive]="child.url || child.uri ? 'active' : ''"
                      [class.active]="child.isActive"
                      (click)="onItemClick($event, child)"
                      tabindex="0"
                      role="button"
                    >
                      <div class="item-content">
                        @if (child.icon) {
                          <ptl-icon [size]="'s'" [icon]="child.icon"></ptl-icon>
                        }
                        <span class="item-title body-s">{{ child.title }}</span>
                      </div>
                    </a>
                  }
                </div>
              }
            }
          </div>
        } @else {
          <a
            class="sidebar-item"
            [routerLink]="item.isBackButton ? null : item.url || item.uri"
            [routerLinkActive]="'active'"
            [class.active]="item.isActive"
            (click)="onItemClick($event, item)"
            tabindex="0"
            role="button"
          >
            @if (!item.isBackButton) {
              <div class="item-content">
                @if (item.icon) {
                  <ptl-icon [size]="'m'" [icon]="item.icon"></ptl-icon>
                }
                <span class="item-title body-s bold">{{ item.title }}</span>
              </div>
            } @else {
              <div class="back-button">
                @if (item.icon) {
                  <ptl-icon [size]="'m'" [icon]="ArrowLeft01Icon"></ptl-icon>
                }
                <div class="button-title body-s bold">{{ 'translations.global.button.back' | transloco }}</div>
              </div>
            }
          </a>
        }
      }
    </div>

    @if (section.showSeparator && !isLast) {
      <div class="section-separator"></div>
    }
  </div>
}
